import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { OdometerWrapperAsync } from 'site-modules/shared/components/odometer-wrapper/odometer-wrapper-async';
import { AffordabilityCalculatorTitleWrapper } from 'site-modules/calculators/components/affordability-calculator-title-wrapper/affordability-calculator-title-wrapper';

/**
 * Renders affordability calculator results step.
 * @param {number} totalDownPayment
 * @param {number} stickerPriceMin
 * @param {number} stickerPriceMax
 * @param {boolean} isLoading
 * @returns {ReactElement}
 */
export function AffordabilityCalculatorStepResults({ totalDownPayment = 0, stickerPriceMin = 0, stickerPriceMax = 0 }) {
  return (
    <Fragment>
      <Row className="mb-1_5">
        <Col xs={12} md={6} className="text-gray-darker mb-0_75 mb-md-0 align-self-center">
          <AffordabilityCalculatorTitleWrapper fontSize={16}>Total Down Payment</AffordabilityCalculatorTitleWrapper>
          <div className="small text-gray-darker">(with net trade-in)</div>
        </Col>
        <Col xs={12} md={6} className="text-start text-md-end">
          <div className="price-odometer fw-bold text-gray-darker" data-test-payment={totalDownPayment}>
            <OdometerWrapperAsync value={totalDownPayment} duration={200} />
          </div>
        </Col>
      </Row>
      <Row className="mb-1_5">
        <Col xs={12} md={6} className="text-gray-darker mb-0_75 mb-md-0 align-self-center">
          <AffordabilityCalculatorTitleWrapper fontSize={16}>Vehicle Price Range</AffordabilityCalculatorTitleWrapper>
        </Col>
        <Col xs={12} md={6} className="text-start text-md-end">
          <div
            className="price-odometer fw-bold text-gray-darker"
            data-test-range={`${stickerPriceMin} - ${stickerPriceMax}`}
          >
            <OdometerWrapperAsync value={stickerPriceMin} duration={200} />
            &nbsp;-&nbsp;
            <OdometerWrapperAsync value={stickerPriceMax} duration={200} />
          </div>
        </Col>
      </Row>
    </Fragment>
  );
}

AffordabilityCalculatorStepResults.propTypes = {
  totalDownPayment: PropTypes.number,
  stickerPriceMin: PropTypes.number,
  stickerPriceMax: PropTypes.number,
};
